import React from 'react';
import Loader from '../../Loader/Loader';


interface ContactDesktopProps {
  name: string;
  email: string;
  message: string;
  alert: { show: boolean; message: string; type: string };
  translations: {
    contactTitle: string;
    contactSubtitle: string;
    contactName: string;
    contactEmail: string;
    contactMessage: string;
    contactMessagePlace: string;
    contactSubmit: string;
  };
  onNameChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onEmailChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onMessageChange: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
  onSubmit: (e: React.FormEvent) => void;
  isLoading: boolean;
}

const ContactDesktop = ({
  name,
  email,
  message,
  alert,
  translations,
  onNameChange,
  onEmailChange,
  onMessageChange,
  onSubmit,
  isLoading
}: ContactDesktopProps) => {
  return (
    <div className="container mx-auto flex justify-center">
      <div className="w-full max-w-4xl px-4">
        {/* Loader overlay */}
        {isLoading && <Loader />}
        
        {alert.show && (
          <div 
            className={`fixed top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 z-50 rounded-md p-4 shadow-lg text-lg font-medium ${alert.type === 'error' ? 'bg-red-100 text-red-700' : 'bg-green-100 text-green-700'}`}
            style={{ transition: 'opacity 0.5s' }}
          >
            {alert.message}
          </div>
        )} 
        <div
          className="mb-12 rounded-sm bg-white px-8 py-11 shadow-three dark:bg-gray-dark sm:p-[55px] lg:mb-5 lg:px-8 xl:p-[55px]"
          data-wow-delay=".15s"
        >
          <h2 className="mb-3 text-2xl font-bold text-black dark:text-white sm:text-3xl lg:text-2xl xl:text-3xl">
            {translations.contactTitle}
          </h2>
          <p className="mb-12 text-base font-medium text-body-color">
            {translations.contactSubtitle}
          </p>
          <form onSubmit={onSubmit}>
            <div className="flex flex-wrap -mx-4">
              <div className="w-full px-4 md:w-1/2">
                <div className="mb-8">
                  <label htmlFor="name" className="mb-3 block text-sm font-medium text-dark dark:text-white">
                    {translations.contactName}
                  </label>
                  <input
                    type="text"                      
                    placeholder={translations.contactName}
                    className="w-full rounded-sm border bg-[#f8f8f8] px-6 py-3 text-base text-body-color outline-none focus:border-primary dark:border-transparent dark:bg-[#2C303B] dark:text-body-color-dark dark:shadow-two dark:focus:border-primary dark:focus:shadow-none"
                    value={name}
                    onChange={onNameChange}
                    disabled={isLoading}
                  />
                </div>
              </div>
              <div className="w-full px-4 md:w-1/2">
                <div className="mb-8">
                  <label htmlFor="email" className="mb-3 block text-sm font-medium text-dark dark:text-white">
                    {translations.contactEmail}
                  </label>
                  <input
                    type="email"
                    placeholder={translations.contactEmail}                        
                    className="w-full rounded-sm border bg-[#f8f8f8] px-6 py-3 text-base text-body-color outline-none focus:border-primary dark:border-transparent dark:bg-[#2C303B] dark:text-body-color-dark dark:shadow-two dark:focus:border-primary dark:focus:shadow-none"
                    value={email}
                    onChange={onEmailChange}
                    disabled={isLoading}
                  />
                </div>
              </div>
              <div className="w-full px-4">
                <div className="mb-8">
                  <label htmlFor="message" className="mb-3 block text-sm font-medium text-dark dark:text-white">
                    {translations.contactMessage}
                  </label>
                  <textarea
                    name="message"
                    rows={5}                      
                    placeholder={translations.contactMessagePlace}
                    className="w-full resize-none rounded-sm border bg-[#f8f8f8] px-6 py-3 text-base text-body-color outline-none focus:border-primary dark:border-transparent dark:bg-[#2C303B] dark:text-body-color-dark dark:shadow-two dark:focus:border-primary dark:focus:shadow-none"
                    value={message}
                    onChange={onMessageChange}
                    disabled={isLoading}
                  ></textarea>
                </div>
              </div>
              <div className="w-full px-4">
              <button 
                type="submit"
                className="rounded-sm bg-primary px-9 py-4 text-base font-medium text-white shadow-submit duration-300 hover:bg-primary/90 dark:shadow-submit-dark flex items-center justify-center" 
                disabled={isLoading}
              >
                {translations.contactSubmit}
              </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default ContactDesktop;